import { FC } from "react";
import BFLLink from "@repo/shared-ui/BFLLink";
import Conditional from "@repo/shared-ui/Conditional";
import { IBreadcrumbContent } from "../../interfaces/ITradingMallContentV1.interface";
import { twMerge } from "tailwind-merge";

interface BreadcrumbsProps {
  content: IBreadcrumbContent;
  compName?: string;
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ content, compName }) => {
  const { breadcrumbItem, heading } = content;
  const orderedItems = Object.values(breadcrumbItem?.[0] || []).sort((a, b) => {
    if (!a.link && b.link) return 1;
    if (a.link && !b.link) return -1;
    return 0;
  });

  // schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: orderedItems.map(({ label, link }, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: label.replace("${companyName}", compName ?? ""),
      item: link || undefined,
    })),
  };

  return (
    <>
      <section className={twMerge(`min-h-[74px] ${compName ? "" : "px-[16px] py-[12px]"}`,content?.customClass ?? "")}>
        <h2 className="mb-3 text-lg font-medium leading-[22px] text-black">
          {heading}
        </h2>
        <nav className="leading-[1.2rem]">
          <ol className="flex flex-nowrap overflow-hidden text-sm capitalize">
            {orderedItems.map(({ label, link }, index) => {
              const formattedLabel = label
                .replace("${companyName}", compName ?? "") ;
              return (
                <li
                  key={"bc-" + index}
                  className={
                    index === orderedItems.length - 1
                      ? "min-w-0 flex-1"
                      : "flex-shrink-0"
                  }
                >
                  <Conditional if={index > 0}>
                    <span className="text-link-primary mx-2 flex-shrink-0 before:content-['>']"></span>
                  </Conditional>
                  <BFLLink
                    href={link}
                    className={`${link ? "text-link-primary" : ""} ${index === orderedItems.length - 1
                        ? "inline-block w-[85%] truncate whitespace-nowrap text-left"
                        : "whitespace-nowrap"
                      }`}
                  >
                    {formattedLabel}
                  </BFLLink>
                </li>
              );
            })}
          </ol>
        </nav>
      </section>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  );
};

export default Breadcrumbs;
